import lsConfig from './lsConfig';

/**
 * A stable part of the config, don't change for any type of the build ['dev', 'stage', 'production']
 */
const config1 = {
  product_name: String(process.env.PRODUCT_NAME),
  build_number: String(process.env.BUILD_NUMBER),
  release_version: String(process.env.RELEASE_VERSION),
};

/**
 * Could be overridden from localStorage for ['dev', 'stage'] builds
 * Not overridden for ['production'] build
 */
const config2 = {
  api_server: String(process.env.API_SERVER),
  ws_server: String(process.env.WS_SERVER),
  web_cac_link: String(process.env.WEB_CUSTOM_APPOINTMENT_CREATE_LINK),

  enable_logs: process.env.ENABLE_LOGS,
  enable_ls_logs: process.env.ENABLE_LIVESWITCH_LOGS,
  enable_log_updates: process.env.ENABLE_LOG_UPDATES || '',
  enable_test_helper: process.env.ENABLE_TEST_HELPERS,
  enable_analytics: process.env.ENABLE_ANALYTICS,

  idle_time: Number(process.env.IDLE_TIMEOUT),
  overdue_time: Number(process.env.OVERDUE_TIMEOUT),
  patients_available_diff_time: Number(process.env.PATIENTS_AVAIL_TIMEOUT),

  default_language: String(process.env.DEFAULT_LANGUAGE || ''),
  org_id: Number(process.env.ORG_ID) || false,

  primary_medium_color: process.env.PRIMARY_MEDIUM_COLOR || '#14A5A7',
};

export const isProduction = process.env.NODE_ENV === 'production';
export const devtoolsEnabled = process.env.ENABLE_DEVTOOLS === '1';

const enhancedConfig2 = isProduction && !devtoolsEnabled ? config2 : lsConfig(config2);

const mergedConfig = {
  ...config1,
  ...enhancedConfig2,
};

export default mergedConfig;
